












import infiniteScroll from 'vue-infinite-scroll';
import { defineComponent } from '@vue/composition-api';

const name = 'ttam-infinite-scroll-container';

export default defineComponent({
  name,

  directives: { infiniteScroll },

  props: {
    disabled: { type: Boolean, default: false },
    distance: { type: Number, default: 20 },
    delay: { type: Number, default: 200 },
  },

  setup(props, { emit }) {
    const onScrollToBottom = () => emit('scroll-to-bottom');

    return {
      name,
      onScrollToBottom,
    };
  },
});
